import { X } from 'lucide-react';
import { BackofficeBrandMark } from './BackofficeBrandMark';
import { BackofficeNavigationLinks } from './BackofficeNavigation';

type BackofficeMobileNavigationProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function BackofficeMobileNavigation({ isOpen, onClose }: BackofficeMobileNavigationProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-40 lg:hidden">
      <button
        type="button"
        aria-label="Close navigation overlay"
        className="absolute inset-0 bg-neutral-900/30"
        onClick={onClose}
      />
      <aside
        id="backoffice-mobile-navigation"
        role="dialog"
        aria-modal="true"
        aria-label="Backoffice navigation menu"
        className="relative flex h-full w-[min(20rem,calc(100vw-3rem))] animate-[backoffice-mobile-nav-in_180ms_ease-out] flex-col border-r border-neutral-200 bg-neutral-50 shadow-modal"
      >
        <div className="flex items-center justify-between border-b border-neutral-200 px-5 py-4">
          <div className="flex flex-col items-end">
            <BackofficeBrandMark logoClassName="h-6 w-auto" />
          </div>
          <button
            type="button"
            aria-label="Close navigation"
            className="focus-ring inline-flex h-9 w-9 items-center justify-center rounded-md text-neutral-600 transition hover:bg-white hover:text-neutral-900"
            onClick={onClose}
          >
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
        <nav aria-label="Mobile backoffice navigation" className="p-5">
          <BackofficeNavigationLinks onNavigate={onClose} />
        </nav>
      </aside>
    </div>
  );
}
